import axios from '../axios';
//查询列表分页信息
export const getBaseEmployeePage = data => {
  return axios({
      url: '/api/sys/base/employee/getBaseEmployeePage',
      method: 'post',
      data
  })
};
//删除
export const deleteBaseEmployees = data => {
  return axios({
      url: '/api/sys/base/employee/deleteBaseEmployees',
      method: 'post',
      data
  })
};
//员工离职操作
export const BaseEmployeeLeaves = data => {
  return axios({
      url: '/api/sys/base/employee/BaseEmployeeLeaves',
      method: 'post',
      data
  })
};
// 员工保存修改
export const saveBaseEmployee = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/base/employee/saveBaseEmployee',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/base/employee/updateBaseEmployee',
      method: 'post',
      data
    })
  }
}
// 根据员工id修改
export const updateBaseEmployee = data => {
  return axios({
    url: '/api/sys/base/employee/updateBaseEmployee',
    method: 'post',
    data
  })
};
// 根据员工id查银行卡
export const getBaseEmployeeBank = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeBank',
        method: 'post',
        data
    })
};
// 根据员工id查证件
export const getBaseEmployeeCertPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeCertPage',
        method: 'post',
        data
    })
};

//员工家庭情况列表
export const getBaseEmployeeFamilyPage = data => {
  return axios({
      url: '/api/sys/base/getBaseEmployeeFamilyPage',
      method: 'post',
      data
  })
};
//员工家庭情况列表删除
export const deleteBaseEmployeeFamilys = data => {
  return axios({
      url: '/api/sys/base/deleteBaseEmployeeFamilys',
      method: 'post',
      data
  })
};
// 员工家庭情况保存修改
export const saveBaseEmployeeFamily = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/base/saveBaseEmployeeFamily',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/base/updateBaseEmployeeFamily',
      method: 'post',
      data
    })
  }
}
//员工证件保存
export const saveBaseEmployeeCert = data => {
  return axios({
      url: '/api/sys/base/saveBaseEmployeeCert',
      method: 'post',
      data
  })
};
//员工教育经历保存
export const saveBaseEmployeeEducation = data => {
  return axios({
      url: '/api/sys/base/saveBaseEmployeeEducation',
      method: 'post',
      data
  })
};
//员工银行卡保存
export const saveBaseEmployeeBank = data => {
  return axios({
      url: '/api/sys/base/saveBaseEmployeeBank',
      method: 'post',
      data
  })
};
//员工工作经历保存修改
export const saveBaseEmployeeWork = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/base/saveBaseEmployeeWork',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/base/updateBaseEmployeeWork',
      method: 'post',
      data
    })
  }
};


//员工 工作经历
export const getBaseEmployeeWorkPage = data => {
  return axios({
      url: '/api/sys/base/getBaseEmployeeWorkPage',
      method: 'post',
      data
  })
};
//员工 工作经历 修改
export const updateBaseEmployeeWork = data => {
  return axios({
      url: '/api/sys/base/updateBaseEmployeeWork',
      method: 'post',
      data
  })
};
//员工 教育经历
export const getBaseEmployeeEducationPage = data => {
  return axios({
      url: '/api/sys/base/getBaseEmployeeEducationPage',
      method: 'post',
      data
  })
};

//员工工作经历删除
export const deleteBaseEmployeeWorks = data => {
  return axios({
      url: '/api/sys/base/deleteBaseEmployeeWorks',
      method: 'post',
      data
  })
};
// 员工入职登记列表
export const getBaseEmployeeEntryPage = data => {
  return axios({
    url: '/api/sys/base/getBaseEmployeeEntryPage',
    method: 'post',
    data
  })
};
// 员工入职登记添加
export const saveBaseEmployeeEntry = data => {
  return axios({
    url: '/api/sys/base/saveBaseEmployeeEntry',
    method: 'post',
    data
  })
};
// 员工入职登记删除
export const deleteBaseEmployeeEntry = data => {
  return axios({
    url: '/api/sys/base/deleteBaseEmployeeEntry',
    method: 'post',
    data
  })
};
// 学历维护列表
export const getBaseSchoolingExpPage = data => {
  return axios({
    url: '/api/sys/getBaseSchoolingExpPage',
    method: 'post',
    data
  })
};
// 导入员工
export const importBaseEmployee = data => {
  return axios({
    url: '/api/sys/base/employee/importBaseEmployee',
    method: 'post',
    data
  })
};
// 分组表列表
export const getBaseGroupPage = data => {
  return axios({
    url: '/api/sys/base/group/getBaseGroupPage',
    method: 'post',
    data
  })
};
// 分组表保存
export const saveBaseGroup = data => {
  return axios({
    url: '/api/sys/base/group/saveBaseGroup',
    method: 'post',
    data
  })
};
// 分组表修改
export const updateBaseGroup = data => {
  return axios({
    url: '/api/sys/base/group/updateBaseGroup',
    method: 'post',
    data
  })
};
// 分组表删除
export const deleteBaseGroups = data => {
  return axios({
    url: '/api/sys/base/group/deleteBaseGroups',
    method: 'post',
    data
  })
};
// 分组表审核
export const auditBaseGroups = data => {
  return axios({
    url: '/api/sys/base/group/auditBaseGroups',
    method: 'post',
    data
  })
};
// 派发项目列表
export const getBaseTaskPage = data => {
  return axios({
    url: '/api/sys/base/task/getBaseTaskPage',
    method: 'post',
    data
  })
};
// 派发项目新增
export const saveBaseTask = data => {
  return axios({
    url: '/api/sys/base/task/saveBaseTask',
    method: 'post',
    data
  })
};
// 派发项目修改
export const updateBaseTask = data => {
  return axios({
    url: '/api/sys/base/task/updateBaseTask',
    method: 'post',
    data
  })
};
// 派发项目删除
export const deleteBaseTasks = data => {
  return axios({
    url: '/api/sys/base/task/deleteBaseTasks',
    method: 'post',
    data
  })
};
// 派发项目审核
export const auditBaseTasks = data => {
  return axios({
    url: '/api/sys/base/task/auditBaseTasks',
    method: 'post',
    data
  })
};
// 分组派发项目列表
export const getBaseGroupTaskPage = data => {
  return axios({
    url: '/api/sys/base/group/task/getBaseGroupTaskPage',
    method: 'post',
    data
  })
};
// 随机派发项目(新增)
export const randomGroupToDistributeTasks = data => {
  return axios({
    url: '/api/sys/base/group/task/randomGroupToDistributeTasks',
    method: 'post',
    data
  })
};
// 分组派发项目新增
export const saveBaseGroupTask = data => {
  return axios({
    url: '/api/sys/base/group/task/saveBaseGroupTask',
    method: 'post',
    data
  })
};
// 分组派发项目修改
export const updateBaseGroupTask = data => {
  return axios({
    url: '/api/sys/base/group/task/updateBaseGroupTask',
    method: 'post',
    data
  })
};
// 分组派发项目修改
export const deleteBaseGroupTasks = data => {
  return axios({
    url: '/api/sys/base/group/task/deleteBaseGroupTasks',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/staff.js